// https://docs.stripe.com/billing/subscriptions/build-subscriptions?platform=web


// import React, { useState, useEffect } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout
// } from '@stripe/react-stripe-js';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Pane, Heading, Paragraph, Button } from 'evergreen-ui';
// import PricingPage from './Pricing';



// const stripePromise = loadStripe('pk_test_51OfrFTHxM7j6JEg1hqlVtVvyBkkOwjBUm5yFG2ZKkyfwbQpQNt09OMGv0DSDID5b4UYkP9yxrAmFhVUfYlcsGcpg00CjV6cJLx');

// const Checkout = () => {
//   const [clientSecret, setClientSecret] = useState(null);
//   const navigate = useNavigate();

//   // Function to fetch the client secret from the backend
//   const fetchClientSecret = async (priceId) => {
//     const response = await fetch('https://api-gmg22qjzza-ue.a.run.app/acct/subscription/create', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ uid: 'user-uid-here', price_id: priceId })
//     });
//     const data = await response.json();
//     if (data.client_secret) {
//       setClientSecret(data.client_secret);
//     } else {
//       console.error('Error creating subscription:', data.error);
//       navigate('/checkout/failure'); // Navigate to failure page if client_secret is not returned
//     }
//   };

//   // Handle session result after payment
//   useEffect(() => {
//     const queryString = window.location.search;
//     const urlParams = new URLSearchParams(queryString);
//     const sessionId = urlParams.get('session_id');

//     if (sessionId) {
//       // Call backend to check the session status
//       fetch(`https://api-gmg22qjzza-ue.a.run.app/acct/subscription/session_status`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ session_id: sessionId })
//       })
//         .then(response => response.json())
//         .then(data => {
//           if (data.status === 'complete') {
//             navigate('/checkout/success', { state: { email: data.customer_email } }); // Navigate to success page with email
//           } else {
//             navigate('/checkout/failure'); // Navigate to failure page
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching session status:', error);
//           navigate('/checkout/failure'); // Navigate to failure page on error
//         });
//     }
//   }, [navigate]);

//   return (
//     <div>
//       <h2>Select a Plan</h2>
//       <button onClick={() => fetchClientSecret('price_1OxJGMHxM7j6JEg1K59lygj7')}>Basic Plan</button>
//       <button onClick={() => fetchClientSecret('price_1OxJGQHxM7j6JEg1K59lygj8')}>Pro Plan</button>
      
//       {clientSecret && (
//         <EmbeddedCheckoutProvider
//           stripe={stripePromise}
//           options={{ clientSecret }}
//         >
//           <EmbeddedCheckout />
//         </EmbeddedCheckoutProvider>
//       )}
//     </div>
//   );
// };





// const Success = () => {
//     const location = useLocation();
//     const email = location.state?.email || 'your email';
  
//     return (
//       <Pane
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         padding={16}
//         margin={24}
//         background="tint2"
//         borderRadius={8}
//       >
//         <Heading size={900} marginBottom={16}>
//           Payment Successful!
//         </Heading>
//         <Paragraph size={500} marginBottom={16}>
//           Thank you for your purchase. A confirmation email has been sent to <strong>{email}</strong>.
//         </Paragraph>
//         <Button appearance="primary" onClick={() => window.location.href = '/dashboard'}>
//           Go to Dashboard
//         </Button>
//       </Pane>
//     );
//   };
  


//   const Failure = () => {
//     const navigate = useNavigate();

//     return (
//       <Pane
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         padding={16}
//         margin={24}
//         background="tint2"
//         borderRadius={8}
//       >
//         <Heading size={900} marginBottom={16}>
//           Payment Failed!
//         </Heading>
//         <Paragraph size={500} marginBottom={16}>
//           Your payment could not be processed. Please try again.
//         </Paragraph>
//         <Button appearance="primary" onClick={() => window.location.href = '/checkout'}>
//           Try Again
//         </Button>

//         <button onClick={() => navigate('/checkout')}>Try Again</button>

//       </Pane>
//     );
//   };
  
// export {Success, Failure};


// export default Checkout;


// import React, { useCallback, useEffect, useState } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Pane, Heading, Spinner, Button, Paragraph } from 'evergreen-ui';
// import PricingPage from './Pricing'; // Import the PricingPage component
// import useStore from '../appservices/store'; // Import Zustand store

// // Load Stripe outside the component to avoid recreating the object on every render
// const stripePromise = loadStripe('pk_test_51OfrFTHxM7j6JEg1hqlVtVvyBkkOwjBUm5yFG2ZKkyfwbQpQNt09OMGv0DSDID5b4UYkP9yxrAmFhVUfYlcsGcpg00CjV6cJLx');

// const Checkout = () => {
//     const { user, stripeCustomerId, isLoading, setIsLoading, setError, setStripeCustomerId } = useStore(); // Use Zustand store
//     const [step, setStep] = useState(1);
//     const navigate = useNavigate();
  
//     // useEffect(() => {
//     //   if (!stripeCustomerId && user) {
//     //     console.log("no stripe customer id and user");
//     //     fetchStripeCustomerId(user.uid);
//     //   }
//     // }, [stripeCustomerId, user]);



//   useEffect(() => {
//     const queryString = window.location.search;
//     const urlParams = new URLSearchParams(queryString);
//     const sessionId = urlParams.get('session_id');

//     if (!stripeCustomerId && user) {
//           console.log("no stripe customer id and user");
//           fetchStripeCustomerId(user.uid);
//         }

//     if (sessionId) {
//       // Call backend to check the session status
//       fetch(`https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/session_status`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ session_id: sessionId })
//       })
//         .then(response => response.json())
//         .then(data => {
//           if (data.status === 'complete') {
//             navigate('/checkout/success', { state: { email: data.customer_email } }); // Navigate to success page with email
//           } else {
//             navigate('/checkout/failure'); // Navigate to failure page
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching session status:', error);
//           navigate('/checkout/failure'); // Navigate to failure page on error
//         });
//     }
//   }, [navigate,stripeCustomerId, user]);














  
//     const fetchStripeCustomerId = async (uid) => {
//       try {
//         console.log('Fetching Stripe customer ID... uid is', uid);
//         setIsLoading(true);
//         const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/fetch_customer_id', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ uid }),
//         });
  
//         const data = await response.json();
//         console.log('data is', data);
//         if (data.customer_id) {
//             console.log("data.customer_id retrieved from stripe", data.customer_id);
//           setStripeCustomerId(data.customer_id); // Save to Zustand store
//         } else {
//             console.log("no data.customer_id retrieved from stripe error ", data.error);
//           throw new Error('Failed to fetch Stripe customer ID.');
//         }
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
  
//     const createCheckoutSession = async (priceId) => {
//       setIsLoading(true);
//       try {
//         const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/create', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ uid: user.uid, price_id: priceId, customer_id: stripeCustomerId }), // Include customer ID
//         });
//         const data = await response.json();
//         setIsLoading(false);
  
//         if (data.session_id) {
//           const stripe = await stripePromise;
//           const { error } = await stripe.redirectToCheckout({ sessionId: data.session_id });
  
//           if (error) {
//             setError('Stripe Checkout error occurred.');
//           }
//         } else {
//           setError('Failed to create a Checkout session.');
//           navigate('/checkout/failure');
//         }
//       } catch (error) {
//         setIsLoading(false);
//         setError('Error occurred during Checkout session creation.');
//         navigate('/checkout/failure');
//       }
//     };

//   // Step 1: Pricing Selection
//   const renderPricing = () => (
//     <Pane>
//       <PricingPage onSelectPlan={(plan, priceId) => createCheckoutSession(priceId)} /> {/* Listen for plan selection */}
//     </Pane>
//   );

//   // Step 3: Confirmation
//   const renderConfirmation = () => (
//     <Pane>
//       <Heading size={700} marginBottom={24}>Thank you for your purchase!</Heading>
//       <Button appearance="primary" onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
//     </Pane>
//   );

//   // Render the current step
//   const renderCurrentStep = () => {
//     switch (step) {
//       case 1: return renderPricing();
//       case 3: return renderConfirmation();
//       default: return renderPricing();
//     }
//   };

//   return (
//     <Pane display="flex" flexDirection="column" alignItems="center" justifyContent="center" padding={16}>
//       {isLoading && <Spinner />}
//       {!isLoading && renderCurrentStep()}
//     </Pane>
//   );
// };

// const Success = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const queryParams = new URLSearchParams(location.search);
//     const sessionId = queryParams.get('session_id');
  
//     // Automatically redirect to dashboard after 5 seconds
//     useEffect(() => {
//       const timer = setTimeout(() => {
//         navigate('/dashboard');
//       }, 5000);
  
//       return () => clearTimeout(timer); // Cleanup on unmount
//     }, [navigate]);
  
//     return (
//       <Pane
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         padding={16}
//         margin={24}
//         background="tint2"
//         borderRadius={8}
//       >
//         <Heading size={900} marginBottom={16}>
//           Payment Successful!
//         </Heading>
//         <Paragraph size={500} marginBottom={16}>
//           Thank you for your purchase. Your session ID is: <strong>{sessionId}</strong>. You will be redirected to your dashboard shortly.
//         </Paragraph>
//         <Button appearance="primary" onClick={() => navigate('/dashboard')}>
//           Go to Dashboard Now
//         </Button>
//       </Pane>
//     );
//   };

//   const Failure = () => {
//     const navigate = useNavigate();
  
//     return (
//       <Pane
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         justifyContent="center"
//         padding={16}
//         margin={24}
//         background="tint2"
//         borderRadius={8}
//       >
//         <Heading size={900} marginBottom={16}>
//           Payment Failed!
//         </Heading>
//         <Paragraph size={500} marginBottom={16}>
//           Your payment could not be processed. Please try again or contact support.
//         </Paragraph>
//         <Button appearance="primary" onClick={() => navigate('/checkout')}>
//           Try Again
//         </Button>
//       </Pane>
//     );
//   };

// export { Success, Failure };
// export default Checkout;






// Checkout.js

// import React, { useEffect, useState } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Pane, Heading, Spinner, Button, Paragraph } from 'evergreen-ui';
// import PricingPage from './Pricing'; // Import the PricingPage component
// import useStore from '../appservices/store'; // Import Zustand store

// // Load Stripe outside the component to avoid recreating the object on every render
// const stripePromise = loadStripe('pk_test_51OfrFTHxM7j6JEg1hqlVtVvyBkkOwjBUm5yFG2ZKkyfwbQpQNt09OMGv0DSDID5b4UYkP9yxrAmFhVUfYlcsGcpg00CjV6cJLx');

// const Checkout = () => {
//     const {
//         user,
//         stripeCustomerId,
//         isLoading,
//         setIsLoading,
//         setError,
//         setStripeCustomerId
//     } = useStore(); // Access Zustand store
//     const navigate = useNavigate();
  
//     // Fetch Stripe customer ID if not already present
//     useEffect(() => {
//         if (!stripeCustomerId && user) {
//             console.log("No Stripe customer ID found. Fetching...");
//             fetchStripeCustomerId(user.uid);
//         }
//     }, [stripeCustomerId, user]);

//     // Function to fetch Stripe Customer ID from backend
//     const fetchStripeCustomerId = async (uid) => {
//         try {
//             console.log('Fetching Stripe customer ID for UID:', uid);
//             setIsLoading(true);
//             const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/fetch_customer_id', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ uid }),
//             });

//             const data = await response.json();
//             console.log('Stripe Customer ID response:', data);
//             if (data.customer_id) {
//                 console.log("Stripe Customer ID retrieved:", data.customer_id);
//                 setStripeCustomerId(data.customer_id); // Update Zustand store
//             } else {
//                 console.error("Error fetching Stripe Customer ID:", data.error);
//                 throw new Error('Failed to fetch Stripe customer ID.');
//             }
//         } catch (error) {
//             console.error('Error fetching Stripe Customer ID:', error);
//             setError(error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };
  
//     // Function to create a Stripe Checkout Session via backend
//     const createCheckoutSession = async (priceId) => {
//         setIsLoading(true);
//         try {
//             const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/create', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     uid: user.uid,
//                     price_id: priceId,
//                     customer_id: stripeCustomerId
//                 }),
//             });
//             const data = await response.json();
//             console.log('Create Checkout Session response:', data);
//             setIsLoading(false);

//             if (data.session_id) {
//                 const stripe = await stripePromise;
//                 const { error } = await stripe.redirectToCheckout({ sessionId: data.session_id });

//                 if (error) {
//                     console.error('Stripe Checkout error:', error);
//                     setError('Stripe Checkout error occurred.');
//                 }
//             } else {
//                 console.error('Failed to create a Checkout session:', data.error);
//                 setError('Failed to create a Checkout session.');
//                 navigate('/checkout/failure');
//             }
//         } catch (error) {
//             console.error('Error creating Checkout session:', error);
//             setIsLoading(false);
//             setError('Error occurred during Checkout session creation.');
//             navigate('/checkout/failure');
//         }
//     };

//     // Step 1: Pricing Selection
//     const renderPricing = () => (
//         <Pane>
//             <PricingPage onSelectPlan={(plan, priceId) => createCheckoutSession(priceId)} />
//         </Pane>
//     );

//     // Optional Step 2: Processing (Not strictly necessary but can provide feedback)
//     const renderProcessing = () => (
//         <Pane>
//             <Spinner />
//             <Heading size={700} marginTop={16}>Processing your payment...</Heading>
//         </Pane>
//     );

//     // Render the current step based on your application flow
//     const renderCurrentStep = () => {
//         // In this implementation, the main Checkout component handles the pricing selection
//         // and initiates the checkout session. The processing is handled via webhooks and
//         // real-time updates on the Success and Failure components.
//         return renderPricing();
//     };

//     return (
//         <Pane display="flex" flexDirection="column" alignItems="center" justifyContent="center" padding={16}>
//             {isLoading && <Spinner />}
//             {!isLoading && renderCurrentStep()}
//             {isLoading && <Heading size={700} marginTop={16}>Processing your payment...</Heading>}
//         </Pane>
//     );
// };

// // Success Component: Displays after successful payment processing via webhook
// const Success = () => {
//     const navigate = useNavigate();
//     const { user } = useStore();
//     const [isSubscribed, setIsSubscribed] = useState(false);
//     const [email, setEmail] = useState('');

//     useEffect(() => {
//         const checkSubscriptionStatus = async () => {
//             try {
//                 const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/get_subscription_status', {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({ uid: user.uid }),
//                 });
//                 const data = await response.json();
//                 console.log('Subscription status response:', data);
//                 if (data.subscription_status === 'active') {
//                     setIsSubscribed(true);
//                     setEmail(data.customer_email);
//                 } else {
//                     setIsSubscribed(false);
//                 }
//             } catch (error) {
//                 console.error('Error fetching subscription status:', error);
//                 setIsSubscribed(false);
//             }
//         };

//         if (user) {
//             checkSubscriptionStatus();
//         }
//     }, [navigate, user]);

//     useEffect(() => {
//         if (isSubscribed) {
//             // Automatically redirect to dashboard after 5 seconds
//             const timer = setTimeout(() => {
//                 navigate('/dashboard');
//             }, 5000);
//             return () => clearTimeout(timer);
//         }
//     }, [isSubscribed, navigate]);

//     return (
//         <Pane
//             display="flex"
//             flexDirection="column"
//             alignItems="center"
//             justifyContent="center"
//             padding={16}
//             margin={24}
//             background="tint2"
//             borderRadius={8}
//         >
//             {isSubscribed ? (
//                 <>
//                     <Heading size={900} marginBottom={16}>
//                         Payment Successful!
//                     </Heading>
//                     <Paragraph size={500} marginBottom={16}>
//                         Thank you for your purchase, {email}! Your subscription is now active.
//                         You will be redirected to your dashboard shortly.
//                     </Paragraph>
//                     <Spinner />
//                 </>
//             ) : (
//                 <>
//                     <Heading size={900} marginBottom={16}>
//                         Subscription Pending
//                     </Heading>
//                     <Paragraph size={500} marginBottom={16}>
//                         Your payment is being processed. Please wait while we verify your subscription.
//                         If the process takes too long, please contact support.
//                     </Paragraph>
//                     <Spinner />
//                 </>
//             )}
//             {!isSubscribed && (
//                 <Button appearance="primary" onClick={() => navigate('/dashboard')} marginTop={16}>
//                     Go to Dashboard
//                 </Button>
//             )}
//         </Pane>
//     );
// };

// // Failure Component: Displays if payment failed
// const Failure = () => {
//     const navigate = useNavigate();

//     return (
//         <Pane
//             display="flex"
//             flexDirection="column"
//             alignItems="center"
//             justifyContent="center"
//             padding={16}
//             margin={24}
//             background="tint2"
//             borderRadius={8}
//         >
//             <Heading size={900} marginBottom={16}>
//                 Payment Failed!
//             </Heading>
//             <Paragraph size={500} marginBottom={16}>
//                 Your payment could not be processed. Please try again or contact support for assistance.
//             </Paragraph>
//             <Button appearance="primary" onClick={() => navigate('/checkout')}>
//                 Try Again
//             </Button>
//         </Pane>
//     );
// };

// export { Success, Failure };
// export default Checkout;

import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router-dom';
import { Pane, Heading, Spinner, Button, Paragraph } from 'evergreen-ui';
import useStore from '../appservices/store'; // Import Zustand store

const stripePromise = loadStripe('pk_test_51OfrFTHxM7j6JEg1hqlVtVvyBkkOwjBUm5yFG2ZKkyfwbQpQNt09OMGv0DSDID5b4UYkP9yxrAmFhVUfYlcsGcpg00CjV6cJLx');

const Checkout = () => {
    const {
        user,
        stripeCustomerId,
        isLoading,
        setIsLoading,
        setError,
        setStripeCustomerId,
    } = useStore();

    const selectedPriceId = 'price_1OxJGLHxM7j6JEg1QmW6GbGA';

    console.log("Selected Price ID is", selectedPriceId, "Stripe Customer ID is", stripeCustomerId);
    const navigate = useNavigate();

    useEffect(() => {
        if (!stripeCustomerId && user) {
            fetchStripeCustomerId(user.uid);
        }
    }, [stripeCustomerId, user]);

    const fetchStripeCustomerId = async (uid) => {
        try {
            setIsLoading(true);
            const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/fetch_customer_id', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ uid }),
            });

            const data = await response.json();
            if (data.customer_id) {
                setStripeCustomerId(data.customer_id);
            } else {
                throw new Error('Failed to fetch Stripe customer ID.');
            }
        } catch (error) {
            console.error('Error fetching Stripe customer ID:', error);
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const createCheckoutSession = async () => {
        if (!stripeCustomerId || !user || !selectedPriceId) return;

        setIsLoading(true);
        try {
            const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    uid: user.uid,
                    price_id: selectedPriceId,
                    customer_id: stripeCustomerId,
                }),
            });
            const data = await response.json();

            if (data.session_id) {
                const stripe = await stripePromise;
                const { error } = await stripe.redirectToCheckout({ sessionId: data.session_id });
                if (error) throw new Error('Stripe Checkout error occurred.');
            } else {
                throw new Error('Failed to create a Checkout session.');
            }
        } catch (error) {
            console.error('Error creating Checkout session:', error);
            setError(error.message);
            navigate('/checkout/failure');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (stripeCustomerId && selectedPriceId) {
            createCheckoutSession();
        }
    }, [stripeCustomerId, selectedPriceId]);

    return (
        <Pane display="flex" flexDirection="column" alignItems="center" justifyContent="center" padding={16}>
            {isLoading ? (
                <>
                    <Spinner />
                    <Heading size={700} marginTop={16}>Processing your payment...</Heading>
                </>
            ) : (
                <Heading size={700} marginTop={16}>Redirecting to payment...</Heading>
            )}
        </Pane>
    );
};

const Success = () => {
    const navigate = useNavigate();
    const { user, setSubscriptionStatus } = useStore();
    const [email, setEmail] = useState('');

    useEffect(() => {
        const fetchSubscriptionStatus = async () => {
            try {
                const response = await fetch('https://aiit-gmg22qjzza-ue.a.run.app/acct/subscription/get_subscription_status', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uid: user.uid }),
                });
                const data = await response.json();

                if (data.subscription_status === 'active') {
                    setSubscriptionStatus('active');
                    setEmail(data.customer_email);
                }
            } catch (error) {
                console.error('Error fetching subscription status:', error);
            }
        };

        if (user) fetchSubscriptionStatus();
    }, [user, setSubscriptionStatus]);

    return (
        <Pane
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding={16}
            margin={24}
            background="tint2"
            borderRadius={8}
        >
            <Heading size={900} marginBottom={16}>
                Payment Successful!
            </Heading>
            <Paragraph size={500} marginBottom={16}>
                Thank you for your purchase{email && `, ${email}`}! Your subscription is now active.
            </Paragraph>
            <Button appearance="primary" onClick={() => navigate('/dashboard')} marginTop={16}>
                Go to Dashboard
            </Button>
        </Pane>
    );
};

const Failure = () => {
    const navigate = useNavigate();

    return (
        <Pane
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding={16}
            margin={24}
            background="tint2"
            borderRadius={8}
        >
            <Heading size={900} marginBottom={16}>
                Payment Failed!
            </Heading>
            <Paragraph size={500} marginBottom={16}>
                Your payment could not be processed. Please try again or contact support for assistance.
            </Paragraph>
            <Button appearance="primary" onClick={() => navigate('/checkout')} marginTop={16}>
                Try Again
            </Button>
        </Pane>
    );
};

export { Success, Failure };
export default Checkout;
